"use client"

import { motion } from "framer-motion"
import { Button } from "./ui/button"
import { ArrowRight } from "lucide-react"

const makers = [
  {
    id: "duffy-london",
    name: "Marnois",
    philosophy: "“Where Mediterranean elegance meets modern design.”",
    quote: "Marnois offers an exclusive collection of high-quality furniture that seamlessly blends contemporary luxury with Mediterranean inspiration. Their curated pieces—ranging from seating and tables to lighting and rugs—are crafted to elevate any space with timeless elegance. With a focus on customization, Marnois allows you to tailor each piece to your unique vision, ensuring that your furniture not only fits your space but also reflects your personal style. Whether you're seeking a statement piece or a subtle accent, Marnois provides the perfect balance of aesthetics and functionality.",
    image: "/CrftbyHmnNeeds_1.png",
    productImage: "/placeholder.svg?height=600&width=800",
  },
  {
    id: "nishita-thakurdas",
    name: "Name Place Animal Thing",
    philosophy: "Where imagination meets craftsmanship.",
    quote: "My work bridges ancient craft techniques with contemporary sensibilities.",
    image: "/CrftbyHmnNeeds_2.png",
    productImage: "/placeholder.svg?height=600&width=800",
  },
  {
    id: "paul-matter",
    name: "Cyanique",
    philosophy: "Design that flows like water, yet leaves no ripple on the planet.",
    quote: "Each piece is designed to transform both space and mood through light.",
    image: "/CrftbyHmnNeeds_3.png",
    productImage: "/placeholder.svg?height=600&width=800",
  },
  {
    id: "jay-strongwater",
    name: "Taho Living",
    philosophy: "Designs with a heart and a heritage.",
    quote: "I approach each design as if it were a piece of fine jewelry for your living space.",
    image: "/CrftbyHmnNeeds_4.png",
    productImage: "/placeholder.svg?height=600&width=800",
  },
  {
    id: "new-maker",
    name: "Neytt Homes",
    philosophy: "Where ancient looms whisper in modern rooms.",
    quote: "Blending timeless tradition with contemporary design for lasting impact.",
    image: "/CrftbyHmnNeeds_5.png",
    productImage: "/placeholder.svg?height=600&width=800",
  },
]

export default function MakersShowcase() {
  return (
    <section className="bg-white py-24 dark:bg-stone-950">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-4 font-serif text-3xl font-light md:text-4xl dark:text-white">Crafted by Human Hands</h2>
          <p className="mx-auto max-w-2xl text-muted-foreground">
            Meet the visionaries and artisans behind our curated collections.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 grid-rows-2">
          {makers.map((maker, index) => (
            <motion.div
              key={maker.id}
              className={`relative overflow-hidden rounded-xl shadow-md group aspect-square ${index === 0 ? 'col-span-2 row-span-2' : ''}`}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <img
                src={maker.image || "/placeholder.svg"}
                alt={maker.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-80" />
              <div className="absolute bottom-0 left-0 p-4 text-white">
                <h3 className="mb-2 font-serif text-xl font-light">{maker.name}</h3>
                <p className="text-xs uppercase tracking-wider text-stone-300">{maker.philosophy}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Meet the Maker Feature */}
      <div className="container mx-auto mt-24 px-4">
        <div className="relative overflow-hidden">
          <div className="grid gap-8 md:grid-cols-2 md:items-center">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h3 className="mb-2 font-serif text-sm uppercase tracking-widest text-amber-700">Featured Brand</h3>
              <h4 className="mb-4 font-serif text-3xl font-light dark:text-white">Cyanique</h4>
              <p className="mb-6 text-muted-foreground">
              Cyanique takes the art of 3D printing and turns it into poetry for your home. Every curve and contour is born from recycled plastic, sculpted into forms that feel as fluid as nature itself. The result? Décor and furniture that are modern yet soulful, innovative yet deeply responsible. 
              </p>
              <p className="mb-8 text-muted-foreground">
              Cyanique doesn’t just fill a space — it changes its energy, proving that the future of design can be both breathtaking and benevolent.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative aspect-[4/3]"
            >
              <img
                src="/CrftbyHmnNeeds_3.png?height=483&width=644"
                alt="Paul Matter in his studio"
                className="w-full h-full object-cover"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
} 